import { render, staticRenderFns } from "./json-upload.vue?vue&type=template&id=03fae882&scoped=true&"
import script from "./json-upload.vue?vue&type=script&lang=js&"
export * from "./json-upload.vue?vue&type=script&lang=js&"
import style0 from "./json-upload.vue?vue&type=style&index=0&id=03fae882&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fae882",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
